import React from "react";

export const Section = ({ label, children }) => (
  <div>
    <div className="mb-1.5 text-[10px] font-bold uppercase tracking-[0.2em] text-slate-500">
      {label}
    </div>
    <div className="text-sm text-slate-800">{children || "—"}</div>
  </div>
);

export const Field = ({ label, value, onChange, testId, type = "text", placeholder, cols = 1 }) => (
  <div className={cols === 2 ? "col-span-2" : ""}>
    <label className="mb-1 block text-[10px] font-bold uppercase tracking-[0.2em] text-slate-500">
      {label}
    </label>
    {type === "textarea" ? (
      <textarea
        data-testid={testId}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        rows={2}
        placeholder={placeholder}
        className="w-full resize-none rounded-md border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none focus:border-nmi-600 focus:ring-2 focus:ring-nmi-600/20"
      />
    ) : (
      <input
        data-testid={testId}
        type={type}
        step={type === "number" ? "any" : undefined}
        value={value ?? ""}
        onChange={(e) => onChange(type === "number" ? (e.target.value === "" ? null : parseFloat(e.target.value)) : e.target.value)}
        placeholder={placeholder}
        className="w-full rounded-md border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none focus:border-nmi-600 focus:ring-2 focus:ring-nmi-600/20"
      />
    )}
  </div>
);
